{{ "report.systemPerformance" | translate }}